<div class="hierarchy-filter-panel" [hidden]="isHierarchFilterHidden" [class.hover]="isHierarchyFilterEnabled">

  <span class="text-nowrap  line-height filter-text-format">{{
    "HIERARCHY" | translate
    }}</span>
  <span class="input-group-text default-access" [class.disabled]="!isHierarchyFilterEnabled" [class.active]="isHierarchFilterActive" id="hierarchy-filter-button"
    (click)="openGlobalFilterSideBar($event)">
    <img src="assets/images/hierarchy.svg" id="set-hierarchy-icon" />
    <!-- <span *ngIf="isHierarchyFilterInitialised && appliedFilter">
                          <span>{{appliedFilter.label}}</span>
                          <span class="text-dark" id="hierarchy-value" role="button" >{{appliedFilter.value}}</span>
                      </span> -->
    <span class="circle-loader" *ngIf="isHierarchyInitializing"></span>
    <span *ngIf="! isHierarchyInitializing && 
          !isHierarchyFilterInitialised &&
          mappedHierarchyLevelNames &&
          loggedInUserLevel
        ">
      <span>{{ mappedHierarchyLevelNames[loggedInUserLevel] }}</span>
      <span *ngIf="loggedInUserValues.length == 1" class="text-dark"  class="hierarchy-selected-value">{{ loggedInUserValues[0] }}</span>
      <span *ngIf="loggedInUserValues.length > 1" class="multi-value-container">
        <span class="text-dark" class="hierarchy-value-selector" id="hierarchy-value-selector" (click)="selectHierarchyValue($event)">
          {{selectedHierarchyValue}} <img [ngStyle]="{ filter: isDropdownOpen ? 'brightness(0) saturate(100%) invert(26%) sepia(89%) saturate(1954%) hue-rotate(204deg) brightness(98%) contrast(101%)' : null, transform: isDropdownOpen ? 'rotate(180deg)' : null }" src="assets/images/menu-down-dark.svg">
        </span>
        <div class="multi-value-dropdown" *ngIf="isDropdownOpen">
          <ul>
            <li *ngFor="let item of loggedInUserValues; let i = index" (click)="selectedHierarchyValue != item ? updateHierarchyFilter(item, $event) : null" [value]="item" [class.active-li]="selectedHierarchyValue == item">{{ item }}</li>
          </ul>
        </div>
      </span>
    </span>
    <img class="chevron-double-right" *ngIf="!isHierarchyInitializing && 
      !isHierarchyFilterInitialised &&
      mappedHierarchyLevelNames &&
      loggedInUserLevel && isHierarchyFilterEnabled 
    " src="./assets/images/chevron-double-right.svg">
  </span>

</div>